import { Media } from '@/components/Media'
import type { TechnologyContent } from '@/lib/content.types'

export function Technology({ data }: { data: TechnologyContent }) {
  return (
    <section
      id="technology"
      className="relative border-y border-line-hairline bg-surface-alt px-5 py-20 md:px-10 md:py-[104px]"
    >
      {/* 모바일에서는 전체 중앙 정렬, md 이상에서는 디자인대로 좌측 정렬 */}
      <div className="mx-auto max-w-content text-center md:text-left">
        <div className="annx-eyebrow mb-3.5">{data.eyebrow}</div>
        <Media
          media={data.logo}
          className="annx-section-logo mb-3"
        />
        <p className="annx-deck mx-auto mb-10 max-w-[560px] md:mx-0 md:mb-12">{data.deck}</p>

        <div className="grid items-stretch gap-8 lg:grid-cols-[1.15fr_1fr] lg:gap-11">
          <div className="relative min-h-[260px] overflow-hidden rounded-media border border-line-media md:min-h-[440px]">
            <Media media={data.visual} />
          </div>

          <ul className="flex list-none flex-col justify-center gap-3.5 p-0">
            {data.items.map((item, i) => (
              <li
                key={item.id}
                className={`flex flex-col items-center gap-3 border-t border-line-divider py-6 md:flex-row md:items-start md:gap-[18px] ${
                  i === data.items.length - 1 ? 'border-b' : ''
                }`}
              >
                <div
                  className="flex h-10 w-10 flex-none items-center justify-center rounded-[11px] border border-line-button font-mono font-semibold"
                  style={{ color: 'var(--accent)' }}
                  aria-hidden="true"
                >
                  {item.number}
                </div>
                <div>
                  <h3 className="mb-1.5 font-display text-xl font-semibold">{item.title}</h3>
                  <p className="text-[14.5px] leading-[1.6] text-ink-secondary">{item.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
